import React from "react";
import CarrinhoItemModel from "../model/CarrinhoItemModel";
import ReactDOM from "react-dom";
import AppState from "../model/AppState";
import ModalObservacoes from "./ModalObservacoes";
import ModalListas from "./ModalListas";
import CarrinhoModel from "../model/CarrinhoModel";
import ProdutoModel from "../model/ProdutoModel";
import NavegadorUtil from "../util/NavegadorUtil";

import { ReactComponent as ImagemRemoverProduto } from "../assets/images/icons/menu/trash.svg";
import { ReactComponent as ImagemAdicionarLista } from "../assets/images/icons/menu/check-square.svg";
import { ReactComponent as ImagemAdicionarObservacao } from "../assets/images/icons/menu/edit.svg";
import DataUtil from "../util/DataUtil";
import ModalCarrinhoMaioridadeRemoverTodos from "./ModalCarrinhoMaioridadeRemoverTodos";
import ProxyPromocaoDAO from "../dataAccess/Proxy/ProxyPromocaoDAO";
import { ObaTipoPromocaoEnum } from "../model/ObaPromocaoModel";
import { Carrinho } from "../Carrinho";

type CarrinhoItemProps = {
  item: CarrinhoItemModel;
  parent: Carrinho;
};

type CarrinhoItemState = {
  showObservacao: boolean;
  showModalObservacoes: boolean;
  showModalLista: boolean;
  showModalRemoverMaioridade: boolean;
  observacao: string;
  erroMaioridade: boolean;
  produtoMaioridade: boolean;
  descontoExtra: number;
  descricaoExtra: string;
};

class CarrinhoItem extends React.Component<
  CarrinhoItemProps,
  CarrinhoItemState
> {
  constructor(props: CarrinhoItemProps) {
    super(props);

    this.incItem = this.incItem.bind(this);
    this.decItem = this.decItem.bind(this);
    this.removeItem = this.removeItem.bind(this);
    this.toggleMenu = this.toggleMenu.bind(this);
    this.toggleObservacao = this.toggleObservacao.bind(this);
    this.saveObservacoes = this.saveObservacoes.bind(this);
    this.toggleModalObservacoes = this.toggleModalObservacoes.bind(this);
    this.toggleModalLista = this.toggleModalLista.bind(this);
    this.hideMaioridade = this.hideMaioridade.bind(this);
    this.saveModalRemoverMaioridade = this.saveModalRemoverMaioridade.bind(this);

    this.state = {
      showObservacao: false,
      showModalObservacoes: false,
      showModalLista: false,
      showModalRemoverMaioridade: false,
      observacao: this.props.item.notas,
      erroMaioridade: false,
      produtoMaioridade: false,
      descontoExtra: 0,
      descricaoExtra: "",
    };
  }

  async componentDidMount() {
    const { item } = this.props;
    
    let produtoMaioridade = await ProdutoModel.requerMaioridade(item.produto);
    let erroMaioridade = produtoMaioridade && (AppState.getMaioridade() !== true);

    const usuarioLogado = AppState.getUsuarioLogado();

    if (!erroMaioridade && usuarioLogado) {
      if (DataUtil.getIdade(usuarioLogado.nascimento) < 18) {
        erroMaioridade = true;
      }
    }

    erroMaioridade && this.setState({erroMaioridade: true});
    produtoMaioridade && this.setState({ produtoMaioridade });
    await this.updatePromocao();

  }

  async componentDidUpdate(
    prevProps: CarrinhoItemProps,
    prevState: CarrinhoItemState
  ): Promise<void> {
    const carrinho: CarrinhoModel = AppState.getCarrinho();
    const carrinhoItem:
      | CarrinhoItemModel
      | undefined = carrinho.carrinhoItens.find(
      (ci) => ci.produto.produtoId === prevProps.item.produto.produtoId
    );
    if (carrinhoItem) {
      if (prevState.observacao !== carrinhoItem.notas) {
        this.setState({ observacao: carrinhoItem.notas });
      }
    }
  }

  async incItem(): Promise<void> {
    const loja = AppState.getLojaSelecionada();
    if (loja && await ProdutoModel.requerMaioridade(this.props.item.produto) && AppState.getMaioridade() !== true) {
      this.setState({ showModalRemoverMaioridade: true });
    } else {
      await AppState.addCarrinhoItem(
        this.props.item.produto,
        this.props.item.notas
      ).then(async ()=> {
        NavegadorUtil.alerta(
          this.props.parent,
          AppState.carrinhoMensagem(this.props.item.produto.produtoId)
        );
        await this.updatePromocao();
        await this.props.parent.updateDeliveryDisponivel();
      }).catch((err) => {
        if (this.props.parent) {
          NavegadorUtil.alerta(
            this.props.parent,
            err.replace(/\\n/, " ")
          );
        }
      });
    }
  }

  async decItem(): Promise<void> {
    const { parent, item } = this.props;

    await AppState.decCarrinhoItem(item.produto, item.notas).then(async ()=> {
      NavegadorUtil.alerta(parent, AppState.carrinhoMensagem(item.produto.produtoId));
      await this.updatePromocao();
      await parent.updateDeliveryDisponivel();
    }).catch((err) => {
      NavegadorUtil.alerta(parent, err.replace(/\\n/, " "));
    });
  }

  async updatePromocao(): Promise<void> {
    const {item} = this.props;
    const loja = AppState.getLojaSelecionada();
    if (loja) {
      ProxyPromocaoDAO.getInstance().getPromocoes(loja).then(async listaPromocoesFF => {
        for (const promo of listaPromocoesFF) {
          if (promo.de <= new Date() && promo.ate >= new Date() && promo.tipo === ObaTipoPromocaoEnum.COMPRE_X_PAGUE_Y) {
            if (promo.lojas.some(l => l.lojaId === loja.lojaId)) {
              const promoProdutos = await ProxyPromocaoDAO.getInstance().getProdutos(loja, promo.id);
              if (promoProdutos) {
                const prod = promoProdutos.find(p => p.produtoId === item.produto.produtoId);

                if (prod) {
                  const qtdDescontos = Math.floor(item.quantidade / promo.compre);
                  if (this.state.descontoExtra !== item.produto.precoDesconto * qtdDescontos) {
                    this.setState({
                      descontoExtra: item.produto.precoDesconto * qtdDescontos,
                    });
                  }
                  if (this.state.descricaoExtra !== ` - Compre ${promo.compre} pague ${promo.pague}`) {
                    this.setState({
                      descricaoExtra: ` - Compre ${promo.compre} pague ${promo.pague}`,
                    });
                  }
                }
              }
            }
          }
        }
      });
    }
  }

  async removeItem(): Promise<void> {
    const { parent, item } = this.props;
    await AppState.remCarrinhoItem(item.produto);
    NavegadorUtil.alerta(parent, AppState.carrinhoMensagem(item.produto.produtoId));
  }

  hideMaioridade(): void {
    this.setState({ showModalRemoverMaioridade: false });
    if (AppState.getMaioridade() === false) {
      NavegadorUtil.alerta(this.props.parent, "Este produto requer maioridade.");
    } else {
      this.incItem();
    }
    if (this.props.parent) {
      this.props.parent.forceUpdate();
    }
  }

  async saveModalRemoverMaioridade(): Promise<void> {
    const { parent } = this.props;
    const carrinho = AppState.getCarrinho();
    for (const item of carrinho.carrinhoItens) {
      const requerMaioridade = await ProdutoModel.requerMaioridade(item.produto);

      if (requerMaioridade) {
        await AppState.remCarrinhoItem(item.produto);
      }
    }
    NavegadorUtil.alerta(parent, "Itens com maioridade obrigatória removidos do carrinho com sucesso");

    this.setState({ showModalRemoverMaioridade: false });
    if (parent) {
      parent.forceUpdate();
    }
  }

  toggleMenu(): any {
    const item: any = ReactDOM.findDOMNode(this.refs.itemRef);
    item.classList.toggle("menu");
  }

  toggleObservacao(): any {
    this.setState({ showObservacao: !this.state.showObservacao });
    const seta: any = ReactDOM.findDOMNode(this.refs.seta);
    seta.classList.toggle("fa-chevron-down");
    seta.classList.toggle("fa-chevron-up");
  }

  saveObservacoes(obs: string): void {
    const { parent, item } = this.props;

    AppState.setCarrinhoItemNota(item.produto.produtoId, obs);

    this.setState({ observacao: obs });
    this.toggleModalObservacoes();

    NavegadorUtil.alerta(parent, "Observação registrada com sucesso");
  }

  toggleModalObservacoes(): void {
    this.setState({ showModalObservacoes: !this.state.showModalObservacoes });
    if (this.state.showModalObservacoes) {
      this.toggleMenu();
    }
  }

  toggleModalLista(): void {
    this.setState({ showModalLista: !this.state.showModalLista });
    if (this.state.showModalLista) {
      this.toggleMenu();
    }
  }

  render(): any {
    const { item } = this.props;
    const { showModalRemoverMaioridade, erroMaioridade, produtoMaioridade, descontoExtra, descricaoExtra } = this.state;

    const loja = AppState.getLojaSelecionada();
    let { precoDesconto, precoOriginal } = item.produto;

    if (loja) {
      return (
        <li className="item" ref="itemRef">
          <div className="product">
            <div className="info">
              <div className="photo">
                <img
                  src={item.produto.imagem}
                  alt={ProdutoModel.getNomeExtra(item.produto, descricaoExtra)}
                  title={ProdutoModel.getNomeExtra(item.produto, descricaoExtra)}
                />
              </div>
              <div className="details">
                <p className="upper">{item.produto.marca}</p>
                <p className="middle">{ProdutoModel.getNomeExtra(item.produto, descricaoExtra)}</p>
                { item.produto.unidade !== "GR" &&
                <p className="bottom">
                  {`R$ ${precoDesconto.toFixed(2).replace(".", ",")}`}
                  &nbsp;<span>{ProdutoModel.getGR(item.produto)}</span> <br/>
                  { precoDesconto < precoOriginal && (
                    <small>R$ {precoOriginal.toFixed(2).replace(".", ",")}</small>
                  )}
                </p>
                }
                { item.produto.unidade === "GR" &&
                <p className="bottom">
                  {`R$ ${(precoDesconto * item.produto.fatorMultiplicacao / 1000).toFixed(2).replace(".", ",")}`}
                  &nbsp;<span>{ProdutoModel.getGR(item.produto)}</span> <br/>
                  { precoDesconto < precoOriginal && (
                    <small>R$ {(precoOriginal * item.produto.fatorMultiplicacao / 1000).toFixed(2).replace(".", ",")}</small>
                  )}
                </p>
                }
              </div>
              <div className="menu">
                <div className="items">
                  <div className="total">
                    { item.produto.unidade === "GR" &&
                    <div className="price">
                      R$ {((precoDesconto * item.produto.fatorMultiplicacao / 1000 * item.quantidade) - descontoExtra).toFixed(2).replace(".", ",")}<br/>
                      <span>{ProdutoModel.getGR(item.produto, item.quantidade)}</span>
                    </div>
                    }
                    { item.produto.unidade !== "GR" &&
                    <div className="price">
                      R$ {((precoDesconto * item.quantidade) - descontoExtra).toFixed(2).replace(".", ",")}<br/>
                    </div>
                    }
                    <div>
                      { precoDesconto < precoOriginal &&
                      <div className="sale">
                        -{(
                          100 -
                          (precoDesconto / precoOriginal) * 100
                        ).toFixed(0)}%
                      </div>
                      }
                    </div>
                  </div>
                  <div>
                    <button onClick={this.decItem} className="remove">
                      -
                    </button>
                    <div className={ `qty ${erroMaioridade && produtoMaioridade ? "alert" : ""}` } onClick={ () => { erroMaioridade && produtoMaioridade && this.incItem() }}>{item.quantidade}</div>
                    <button onClick={this.incItem} className="add">
                      +
                    </button>
                  </div>
                </div>
                <i
                  className="icon fas fa-chevron-left"
                  onClick={this.toggleMenu}
                ></i>
              </div>
            </div>
            <div className="actions">
              <button className="rem" onClick={this.removeItem}>
                <ImagemRemoverProduto />
                Remover<br/>
                produto
              </button>
              <button className="add" onClick={this.toggleModalLista}>
                <ImagemAdicionarLista />
                Adicionar<br/>
                a uma lista
              </button>
              <button className="obs" onClick={this.toggleModalObservacoes}>
                <ImagemAdicionarObservacao />
                Adicionar<br/>
                observação
              </button>
            </div>
          </div>
          <div className="notes">
            <div 
              className="notes-title"
              onClick={this.toggleObservacao}
            >
              <div className="detail">OBSERVACÕES</div>
              <i className="icon fas fa-chevron-down" ref="seta"></i>
            </div>
            {this.state.showObservacao && (
              <>
                {item.notas && item.notas.length > 0 && (
                  <p className="notes-text">{item.notas}</p>
                )}
                {(!item.notas || (item.notas && item.notas.length === 0)) && (
                  <p className="notes-text">
                    <i>Nenhuma observação informada</i>
                  </p>
                )}
              </>
            )}
          </div>
          <ModalListas
            produto={item.produto}
            toggleModalLista={this.toggleModalLista}
            visivel={this.state.showModalLista}
            observacao={item.notas}
            parent={this.props.parent}
          ></ModalListas>
          <ModalObservacoes
            observacao={item.notas}
            visivel={this.state.showModalObservacoes}
            save={this.saveObservacoes}
            hide={this.toggleModalObservacoes}
          ></ModalObservacoes>
          { showModalRemoverMaioridade &&
            <ModalCarrinhoMaioridadeRemoverTodos
            visivel={this.state.showModalRemoverMaioridade}
            save={this.saveModalRemoverMaioridade}
            hide={this.hideMaioridade}
            ></ModalCarrinhoMaioridadeRemoverTodos>
            }
        </li>
      );
    }
    return <></>;
  }
}

export default CarrinhoItem;
